import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../../core';
import { IDeviceTopicsApiClient } from './i-device-topics-api.client';
import { DeviceTopicsApiClient } from './device-topics.api.client';
import { DeviceTopicsInMemoryApiClient } from './device-topics.api.inmemory.client';

@Injectable({
  providedIn: 'root'
})
export class DeviceTopicsApiClientProvider extends ApiClientProvider<IDeviceTopicsApiClient> {
  constructor(
    private client: DeviceTopicsApiClient,
    private inMemoryClient: DeviceTopicsInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IDeviceTopicsApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IDeviceTopicsApiClient {
    return this.client;
  }
}
